import * as React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid2';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';
import { styled } from '@mui/material/styles';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import RssFeedRoundedIcon from '@mui/icons-material/RssFeedRounded';
import {  useTheme } from '@mui/material/styles';

import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import { Helmet } from 'react-helmet';
import salemToBangalore from './SalemToBangalore';
const cardData = [
  {
    img: '/images/salem-to-yercaud.jpeg',
    tag: 'Tourism',
    title: 'Salem to Yercaud Taxi Service - Affordable Rides to the Scenic Hill Station',
    description:
      'Book a taxi from Salem to Yercaud, the stunning hill station known for its natural beauty and peaceful surroundings. Our taxi service ensures a comfortable ride for families, solo travelers, or groups visiting Yercaud Lake, Killiyur Falls, and the Botanical Garden. Explore the best taxi service to Yercaud at affordable rates, available 24/7. Choose between round trips or one-way drops.',
    alt: 'Taxi from Salem to Yercaud Hill Station',
    authors: [{ name: 'Taxi Expert', avatar: '/static/images/avatar/1.jpg' }],
  },
  {
    img: '/images/salem-to-thirupathi.jpeg',
    tag: 'Pilgrimage',
    title: 'Salem to Tirupati Taxi - Comfortable Rides to the Sacred Temple Town',
    description:
      'Visit the famous Tirumala Venkateswara Temple in Tirupati with our premium taxi service from Salem. Whether you’re traveling for a spiritual experience or a family pilgrimage, our professional drivers ensure a safe and pleasant journey. Book Salem to Tirupati taxis with clean vehicles and reliable service. Ideal for devotees and tourists.',
    alt: 'Taxi from Salem to Tirupati Temple',
    authors: [{ name: 'Travel Guru', avatar: '/static/images/avatar/2.jpg' }],
  },
  {
    img: '/images/salem-to-bangalore.jpeg',
    tag: 'City Travel',
    title: 'Salem to Bangalore Taxi Service - Fast and Reliable City Transfers',
    description:
      'Need a fast and comfortable taxi ride from Salem to Bangalore? Our taxi service provides city transfers for business trips, leisure travel, or airport pickups. Enjoy smooth, traffic-optimized routes with our experienced drivers. Book your Salem to Bangalore cab now and travel in style and comfort. We offer round-the-clock service with hassle-free booking.',
    alt: 'Taxi from Salem to Bangalore',
    authors: [{ name: 'City Chauffeur', avatar: '/static/images/avatar/3.jpg' }],
  },
  {
    img: '/images/salem-to-madurai.jpeg',
    tag: 'Tourism',
    title: 'Salem to Madurai Taxi Service - Explore the Historic City with Ease',
    description:
      'Travel from Salem to Madurai, the ancient city known for the Meenakshi Temple and its rich cultural heritage. Our taxi service offers direct and comfortable rides, making your journey pleasant and relaxing. Book a one-way or round-trip taxi from Salem to Madurai today, with competitive rates and flexible scheduling.',
    alt: 'Taxi from Salem to Madurai',
    authors: [{ name: 'Heritage Explorer', avatar: '/static/images/avatar/4.jpg' }],
  },
  {
    img: '/images/salem-to-coimbatore.jpeg',
    tag: 'City Travel',
    title: 'Salem to Coimbatore Taxi Service - Quick and Safe Transportation',
    description:
      'Looking for a reliable taxi from Salem to Coimbatore? Our taxis offer safe and efficient transportation, perfect for business or family trips. Travel in comfort and enjoy the scenic beauty along the way. Book your taxi from Salem to Coimbatore today for the best rates and quality service.',
    alt: 'Taxi from Salem to Coimbatore',
    authors: [{ name: 'Travel Expert', avatar: '/static/images/avatar/5.jpg' }],
  },
  {
    img: '/images/salem-to-ooty.jpeg',
    tag: 'Tourism',
    title: 'Salem to Ooty Taxi Service - Scenic Rides to the Queen of Hill Stations',
    description:
      'Book your taxi from Salem to Ooty and experience the breathtaking landscapes of Tamil Nadu’s most famous hill station. Our taxis provide comfortable rides to Ooty’s top attractions, including Ooty Lake, Doddabetta Peak, and the Botanical Gardens. Perfect for family vacations, honeymooners, or adventure seekers. Affordable and reliable taxi service at your fingertips.',
    alt: 'Taxi from Salem to Ooty',
    authors: [{ name: 'Hill Station Guide', avatar: '/static/images/avatar/6.jpg' }],
  },
  {
    img: '/images/salem-to-kodaikanal.jpeg',
    tag: 'Tourism',
    title: 'Salem to Kodaikanal Taxi Service - Travel to the Princess of Hill Stations',
    description:
      'Travel from Salem to Kodaikanal in comfort with our reliable taxi service. Whether you’re visiting for the lakes, waterfalls, or beautiful views, our taxis provide the best experience for your journey. Book Salem to Kodaikanal cabs for a stress-free and scenic ride through the Western Ghats.',
    alt: 'Taxi from Salem to Kodaikanal',
    authors: [{ name: 'Nature Lover', avatar: '/static/images/avatar/7.jpg' }],
  },
  {
    img: '/images/salem-to-kanyakumari.jpeg',
    tag: 'Tourism',
    title: 'Salem to Kanyakumari Taxi Service - Journey to the Southern Tip of India',
    description:
      'Book a taxi from Salem to Kanyakumari, where the three seas meet. Our taxis ensure a comfortable long-distance ride, perfect for those looking to explore the Vivekananda Rock Memorial, the Thiruvalluvar Statue, and Kanyakumari Beach. Experience seamless travel and affordable rates for a journey to the southernmost point of India.',
    alt: 'Taxi from Salem to Kanyakumari',
    authors: [{ name: 'Coastal Explorer', avatar: '/static/images/avatar/8.jpg' }],
  },
  {
    img: '/images/salem-to-chennai.jpeg',
    tag: 'City Travel',
    title: 'Salem to Chennai Taxi Service - Efficient Transfers to Tamil Nadu’s Capital',
    description:
      'Planning a trip from Salem to Chennai? Our taxi service provides a convenient and efficient way to travel to Tamil Nadu’s bustling capital city. Whether you need a taxi for business, shopping, or leisure travel, we offer timely pick-ups and smooth city transfers. Enjoy stress-free travel to Chennai’s top destinations, including Marina Beach, Fort St. George, and T. Nagar. Book your Salem to Chennai taxi today for comfortable and affordable rides.',
    alt: 'Taxi from Salem to Chennai',
    authors: [{ name: 'City Chauffeur', avatar: '/static/images/avatar/9.jpg' }],
  },
  {
    img: '/images/salem-to-oganakkal.jpeg',
    tag: 'Tourism',
    title: 'Salem to Oganakkal Falls Taxi Service - Explore the Stunning Waterfalls',
    description:
      'Book your taxi from Salem to Oganakkal Falls, often called the “Niagara of India.” Enjoy the scenic beauty of this famous waterfall, located on the Kaveri River. Ideal for nature lovers, photographers, and adventure seekers, our taxi service ensures a comfortable ride to Oganakkal. With boat rides and beautiful landscapes to enjoy, Oganakkal is the perfect weekend getaway from Salem. Our taxis offer affordable rates and flexible booking options.',
    alt: 'Taxi from Salem to Oganakkal Falls',
    authors: [{ name: 'Waterfall Enthusiast', avatar: '/static/images/avatar/1.jpg' }],
  },
  {
    img: '/images/salem-to-mettur-dam.jpeg',
    tag: 'Tourism',
    title: 'Salem to Mettur Dam Taxi Service - Comfortable Rides to the Historic Dam',
    description:
      'Book a taxi from Salem to Mettur Dam, one of Tamil Nadu’s largest dams and a popular tourist destination. Whether you’re visiting for sightseeing, a picnic, or to learn about the dam’s history, our taxi service offers reliable and comfortable transportation. Explore the scenic surroundings of Stanley Reservoir and enjoy a peaceful day trip. Our taxis provide affordable and safe rides to Mettur Dam, perfect for families, groups, or solo travelers.',
    alt: 'Taxi from Salem to Mettur Dam',
    authors: [{ name: 'Heritage Traveler', avatar: '/static/images/avatar/2.jpg' }],
  },
  {
    img: '/images/salem-to-thanjavur.jpeg',
    tag: 'Tourism',
    title: 'Salem to Thanjavur Taxi Service - Explore the Cultural Capital of Tamil Nadu',
    description:
      'Travel from Salem to Thanjavur, known for the iconic Brihadeeswarar Temple and its rich cultural heritage. Our taxi service ensures a smooth and comfortable ride to Thanjavur, whether you’re visiting for religious purposes or to explore the historical landmarks. Book a one-way or round-trip taxi to Thanjavur and experience the architectural marvels, including the Royal Palace, Saraswathi Mahal Library, and more. Our service is available at affordable rates with flexible booking options.',
    alt: 'Taxi from Salem to Thanjavur',
    authors: [{ name: 'Cultural Explorer', avatar: '/static/images/avatar/3.jpg' }],
  },
  {
    img: '/images/salem-to-chennai.jpeg',
    tag: 'City Travel',
    title: 'Salem to Chennai Taxi Service - Efficient Transfers to Tamil Nadu’s Capital',
    description:
      'Planning a trip from Salem to Chennai? Our taxi service provides a convenient and efficient way to travel to Tamil Nadu’s bustling capital city. Whether you need a taxi for business, shopping, or leisure travel, we offer timely pick-ups and smooth city transfers. Enjoy stress-free travel to Chennai’s top destinations, including Marina Beach, Fort St. George, and T. Nagar. Book your Salem to Chennai taxi today for comfortable and affordable rides.',
    alt: 'Taxi from Salem to Chennai',
    authors: [{ name: 'City Chauffeur', avatar: '/static/images/avatar/4.jpg' }],
  }
];



const SyledCard = styled(Card)(() => {
  const theme = useTheme();  // Access the default theme here
  return {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    '&:hover': {
      backgroundColor: 'transparent',
      cursor: 'pointer',
    },
    '&:focus-visible': {
      outline: '3px solid',
      outlineColor: 'hsla(210, 98%, 48%, 0.5)',
      outlineOffset: '2px',
    },
  };
});

const SyledCardContent = styled(CardContent)({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
  padding: 16,
  flexGrow: 1,
  '&:last-child': {
    paddingBottom: 16,
  },
});

const StyledTypography = styled(Typography)({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

function Author({ authors }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 2,
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px',
      }}
    >
      <Box
        sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center' }}
      >
        <AvatarGroup max={3}>
          {authors.map((author, index) => (
            <Avatar
              key={index}
              alt={author.name}
              src={author.avatar}
              sx={{ width: 24, height: 24 }}
            />
          ))}
        </AvatarGroup>
        <Typography variant="caption">
          {authors.map((author) => author.name).join(', ')}
        </Typography>
      </Box>
      <Typography variant="caption">July 14, 2021</Typography>
    </Box>
  );
}

Author.propTypes = {
  authors: PropTypes.arrayOf(
    PropTypes.shape({
      avatar: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export function Search() {
  return (
    <FormControl sx={{ width: { xs: '100%', md: '25ch' } }} variant="outlined">
      <OutlinedInput
        size="small"
        id="search"
        placeholder="Search…"
        sx={{ flexGrow: 1 }}
        startAdornment={
          <InputAdornment position="start" sx={{ color: 'text.primary' }}>
            <SearchRoundedIcon fontSize="small" />
          </InputAdornment>
        }
        inputProps={{
          'aria-label': 'search',
        }}
      />
    </FormControl>
  );
}

export default function MainContent() {
  const [focusedCardIndex, setFocusedCardIndex] = React.useState(null);

  const handleFocus = (index) => {
    setFocusedCardIndex(index);
  };

  const handleBlur = () => {
    setFocusedCardIndex(null);
  };

  const navigate = useNavigate();

  // Handler to navigate to booking form
  const handleClick = () => {
    navigate('/salemToBangalore'); // This assumes you have a route for booking form
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
    <Helmet>
    <meta charset="UTF-8" />
 <meta name="viewport" content="width=device-width, initial-scale=1.0" />
 <meta property="og:type" content="website" />
 <meta property="og:site_name" content="SVR Taxi Service | Call to book 9965821750" />
 <meta charset="UTF-8" />
 <meta name="viewport" content="width=device-width, initial-scale=1.0" />
 <meta name="description" content="Reliable, taxi, service, in Salem, and, across India. Available 24/7 with professional drivers and affordable pricing. Book now for a comfortable journey."/>
 <meta name="keywords" content="best cab service in salem ,Salem to Yercaud Taxi Service - Affordable Rides to the Scenic Hill Station,Salem to Tirupati Taxi - Comfortable Rides to the Sacred Temple Town, Salem to Bangalore Taxi Service - Fast and Reliable City Transfers,Salem to Madurai Taxi Service - Explore the Historic City with Ease,Salem to Coimbatore Taxi Service - Quick and Safe Transportation,
Salem to Ooty Taxi Service - Scenic Rides to the Queen of Hill Stations, Salem to Kodaikanal Taxi Service - Travel to the Princess of Hill Stations , Salem to Kanyakumari Taxi Service - Journey to the Southern Tip of India , Salem to Chennai Taxi Service - Efficient Transfers to Tamil Nadu’s Capital , Salem to Oganakkal Falls Taxi Service - Explore the Stunning Waterfalls , Salem to Mettur Dam Taxi Service - Comfortable Rides to the Historic Dam , Salem to Thanjavur Taxi Service - Explore the Cultural Capital of Tamil Nadu ,taxi ,service, Salem, India, airport, transfers, intercity, travel, taxi ,booking,svr taxi,Affordable, taxi ,service ,from ,Salem, to ,Chennai,Best, outstation, cab ,service, from ,Salem ,to ,Kodaikanal,Taxi ,service ,for ,day, trips, in ,and, around, Salem,One-way ,taxi ,service ,from ,Salem ,to ,Bangalore,Book ,a, cab, for ,Salem to ,Tiruchirappalli ,trip,Salem to ,Yercaud ,cab ,service for ,family ,trips,Reliable ,24-hour, taxi, service in Salem,Taxi booking, for airport transfers, in Salem,Safe, taxi, service ,for solo ,women, travelers ,in Salem,Outstation, cab, services ,from Salem ,for business ,trips,Affordable car ,rental ,for Salem, sightseeing,Affordable ,Salem to ,Ooty, weekend, tour ,packages,Salem to ,Munnar, taxi, service with sightseeing packages,Pilgrimage, taxi service from, Salem to ,Samayapuram, Temple,
    Budget ,taxi, packages, from Salem to ,Hogenakkal, Falls,Cab service for Salem to ,Kodaikanal, honeymoon, package,Luxury, taxi service, for ,corporate ,trips, from Salem to ,Chennai,Round-trip, taxi ,service ,from Salem to, Mysore,Car, rental, with, driver, for ,outstation trips, in ,Tamil Nadu,Customized, tour packages, with taxi service in Tamil Nadu,
    Cheap, cab ,service for ,outstation trips, from Salem, best, taxi service in salem , best , taxi , service , Best taxi service in salem , Best Cab service in salem"/>
 <meta name="author" content="SVR Taxi" />
 <link rel="canonical" href="https://svrtaxi.netlify.app/blog" />
{/* {    <link rel="icon" href="%PUBLIC_URL%/favicon.ico" type="image/x-icon" /> } */}

<meta property="og:locale" content="en_IN" />
        <meta property="og:url" content="https://svrtaxi.netlify.app/"/>
        <meta property="og:image" content="https://svrtaxi.netlify.app/VisitingCard.jpg" />
 <meta property="og:title" content="Taxi & Cab Service in salem | Cabs Service in salem" />
 <meta property="og:description" content="Providing safe, reliable, and affordable taxi services in Salem and across India. Book now for a hassle-free experience."/>
  <title>8 Rupess Per KiloMeter | Cab & Cabs Available in Salem | SVR Tour's and Travels</title>

 <link rel="stylesheet" href="%PUBLIC_URL%/styles.css"/>
 <link rel="preconnect" href="https://fonts.googleapis.com"/>
 <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
 <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet" />

 
 </Helmet>
      <div>
        <Typography variant="h1" gutterBottom>
          Blog
        </Typography>
        <Typography variant='h1' style={{fontSize:'60px',fontWeight:'bolder'}}>Salem Best Cab Service Explored Places </Typography>
        
<Grid sx={{marginTop:10}}>
              <h1 style={{fontSize:'larger'}}>Taxi Service in Salem </h1><br/>      <hr/>
              <Box>
              <h6>
Looking for the <h1 style={{fontSize:'18px',display:'inline-flex', fontWeight:'100px'}}>Best cab service in Salem </h1>? Look no further than SVR Taxi, your trusted partner for safe, reliable, and affordable transportation. Whether you need a ride across town or a long-distance journey, we provide top-notch service with professional drivers and well-maintained vehicles, ensuring a comfortable experience for every trip.
</h6>
</Box>
</Grid>
      </div>
      <Box
        sx={{
          display: { xs: 'flex', sm: 'none' },
          flexDirection: 'row',
          gap: 1,
          width: { xs: '100%', md: 'fit-content' },
          overflow: 'auto',
        }}
      >
        <Search />
        <IconButton size="small" aria-label="RSS feed">
          <RssFeedRoundedIcon />
        </IconButton>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column-reverse', md: 'row' },
          width: '100%',
          justifyContent: 'space-between',
          alignItems: { xs: 'start', md: 'center' },
          gap: 4,
          overflow: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'inline-flex',
            flexDirection: 'row',
            gap: 3,
            overflow: 'auto',
          }}
        >
          <Chip onClick={handleClick} size="medium" label="All categories" />
          <Chip
            onClick={handleClick}
            size="medium"
            label="Company"
            sx={{
              backgroundColor: 'transparent',
              border: 'none',
            }}
          />
          <Chip
            onClick={handleClick}
            size="medium"
            label="Product"
            sx={{
              backgroundColor: 'transparent',
              border: 'none',
            }}
          />
          <Chip
            onClick={handleClick}
            size="medium"
            label="Design"
            sx={{
              backgroundColor: 'transparent',
              border: 'none',
            }}
          />
          <Chip
            onClick={handleClick}
            size="medium"
            label="Engineering"
            sx={{
              backgroundColor: 'transparent',
              border: 'none',
            }}
          />
        </Box>
        <Box
          sx={{
            display: { xs: 'none', sm: 'flex' },
            flexDirection: 'row',
            gap: 1,
            width: { xs: '100%', md: 'fit-content' },
            overflow: 'auto',
          }}
        >
          <Search />
          <IconButton size="small" aria-label="RSS feed">
            <RssFeedRoundedIcon />
          </IconButton>
        </Box>
      </Box>
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12, md: 6 }}>
          <SyledCard
            variant="outlined"
            onFocus={() => handleFocus(0)}
            onBlur={handleBlur}
            tabIndex={0}
            className={focusedCardIndex === 0 ? 'Mui-focused' : ''}
          >
            <CardMedia
              component="img"
              alt="green iguana"
              image={cardData[0].img}
              aspect-ratio="16 / 9"
              sx={{
                borderBottom: '1px solid',
                borderColor: 'divider',
              }}
            />
            <SyledCardContent>
              <Typography gutterBottom variant="caption" component="h1" style={{fontSize:'larger'}}>
                {cardData[0].tag}
              </Typography>
              <Typography gutterBottom variant="h1" component="h1" style={{fontSize:'medium'}}>
                {cardData[0].title}
              </Typography>
              <StyledTypography variant="body2" color="text.secondary" gutterBottom>
                {cardData[0].description}
              </StyledTypography>
            </SyledCardContent>
            <Author authors={cardData[0].authors} />
          </SyledCard>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <SyledCard
            variant="outlined"
            onFocus={() => handleFocus(1)}
            onBlur={handleBlur}
            tabIndex={0}
            className={focusedCardIndex === 1 ? 'Mui-focused' : ''}
          >
            <CardMedia
              component="img"
              alt="green iguana"
              image={cardData[1].img}
              aspect-ratio="16 / 9"
              sx={{
                borderBottom: '1px solid',
                borderColor: 'divider',
              }}
            />
            <SyledCardContent>
              <Typography gutterBottom variant="h1" component="h1" style={{fontSize:'larger'}}>
                {cardData[1].tag}
              </Typography>
              <Typography gutterBottom variant="h1" component="h1" style={{fontSize:'medium'}}>
               <strong> {cardData[1].title} </strong>
              </Typography>
              <StyledTypography variant="body2" color="text.secondary" gutterBottom>
                {cardData[1].description}
              </StyledTypography>
            </SyledCardContent>
            <Author authors={cardData[1].authors} />
          </SyledCard>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <SyledCard
            variant="outlined"
            onFocus={() => handleFocus(2)}
            onBlur={handleBlur}
            tabIndex={0}
            className={focusedCardIndex === 2 ? 'Mui-focused' : ''}
            sx={{ height: '100%' }}
          >
            <CardMedia
              component="img"
              alt="green iguana"
              image={cardData[2].img}
              sx={{
                height: { sm: 'auto', md: '50%' },
                aspectRatio: { sm: '16 / 9', md: '' },
              }}
            />
            <SyledCardContent>
              <Typography gutterBottom variant="caption" component="h1" style={{fontSize:'larger'}}>
                {cardData[2].tag}
              </Typography>
              <Typography gutterBottom variant="h1" component="h1" style={{fontSize:'medium'}}>
              <strong>{cardData[2].title}</strong>
              </Typography>
              <StyledTypography variant="body2" color="text.secondary" gutterBottom>
                {cardData[2].description}
              </StyledTypography>
            </SyledCardContent>
            <Author authors={cardData[2].authors} />
          </SyledCard>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <Box
            sx={{ display: 'flex', flexDirection: 'column', gap: 2, height: '100%' }}
          >
            <SyledCard
              variant="outlined"
              onFocus={() => handleFocus(3)}
              onBlur={handleBlur}
              tabIndex={0}
              className={focusedCardIndex === 3 ? 'Mui-focused' : ''}
              sx={{ height: '100%' }}
            >
                   <CardMedia
              component="img"
              alt="green iguana"
              image={cardData[3].img}
              sx={{
                height: { sm: 'auto', md: '50%' },
                aspectRatio: { sm: '16 / 9', md: '' },
              }}
            />
              <SyledCardContent
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  height: '100%',
                }}
              >
                <div>
                  <Typography gutterBottom variant="caption" component="h1" style={{fontSize:'larger'}}>
                    {cardData[3].tag}
                  </Typography>
                  <Typography gutterBottom variant="h1" component="h1" style={{fontSize:'medium'}}>
                    {cardData[3].title}
                  </Typography>
                  <StyledTypography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    {cardData[3].description}
                  </StyledTypography>
                
                </div>
              </SyledCardContent>
              <Author authors={cardData[3].authors} />
            </SyledCard>
            <SyledCard
              variant="outlined"
              onFocus={() => handleFocus(4)}
              onBlur={handleBlur}
              tabIndex={0}
              className={focusedCardIndex === 4 ? 'Mui-focused' : ''}
              sx={{ height: '100%' }}
            >
                   <CardMedia
              component="img"
              alt="green iguana"
              image={cardData[4].img}
              sx={{
                height: { sm: 'auto', md: '50%' },
                aspectRatio: { sm: '16 / 9', md: '' },
              }}
            />
              <SyledCardContent
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  height: '100%',
                }}
              >
                <div>
                  <Typography gutterBottom variant="caption" component="h1" style={{fontSize:'larger'}}>
                    {cardData[4].tag}
                  </Typography>
                  <Typography gutterBottom variant="h1" component="h1" style={{fontSize:'medium'}}>
                    {cardData[4].title}
                  </Typography>
                  <StyledTypography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    {cardData[4].description}
                  </StyledTypography>
                </div>
              </SyledCardContent>
              <Author authors={cardData[4].authors} />
            </SyledCard>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <SyledCard
            variant="outlined"
            onFocus={() => handleFocus(5)}
            onBlur={handleBlur}
            tabIndex={0}
            className={focusedCardIndex === 5 ? 'Mui-focused' : ''}
            sx={{ height: '100%' }}
          >
            <CardMedia
              component="img"
              alt="green iguana"
              image={cardData[5].img}
              sx={{
                height: { sm: 'auto', md: '50%' },
                aspectRatio: { sm: '16 / 9', md: '' },
              }}
            />
            <SyledCardContent>
              <Typography gutterBottom variant="caption" component="h1" style={{fontSize:'larger'}}>
                {cardData[5].tag}
              </Typography>
              <Typography gutterBottom variant="h1" component="h1" style={{fontSize:'medium'}}>
                {cardData[5].title}
              </Typography>
              <StyledTypography variant="body2" color="text.secondary" gutterBottom>
                {cardData[5].description}
              </StyledTypography>
            </SyledCardContent>
            <Author authors={cardData[5].authors} />
          </SyledCard>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <SyledCard
            variant="outlined"
            onFocus={() => handleFocus(5)}
            onBlur={handleBlur}
            tabIndex={0}
            className={focusedCardIndex === 5 ? 'Mui-focused' : ''}
            sx={{ height: '100%' }}
          >
            <CardMedia
              component="img"
              alt="green iguana"
              image={cardData[6].img}
              sx={{
                height: { sm: 'auto', md: '50%' },
                aspectRatio: { sm: '16 / 9', md: '' },
              }}
            />
            <SyledCardContent>
              <Typography gutterBottom variant="caption" component="h1" style={{fontSize:'larger'}}>
                {cardData[6].tag}
              </Typography>
              <Typography gutterBottom variant="h1" component="h1" style={{fontSize:'medium'}}>
                {cardData[6].title}
              </Typography>
              <StyledTypography variant="body2" color="text.secondary" gutterBottom>
                {cardData[6].description}
              </StyledTypography>
            </SyledCardContent>
            <Author authors={cardData[6].authors} />
          </SyledCard>
        </Grid>
        
        <Grid size={{ xs: 12, md: 4 }}>
          <SyledCard
            variant="outlined"
            onFocus={() => handleFocus(5)}
            onBlur={handleBlur}
            tabIndex={0}
            className={focusedCardIndex === 5 ? 'Mui-focused' : ''}
            sx={{ height: '100%' }}
          >
            <CardMedia
              component="img"
              alt="green iguana"
              image={cardData[7].img}
              sx={{
                height: { sm: 'auto', md: '50%' },
                aspectRatio: { sm: '16 / 9', md: '' },
              }}
            />
            <SyledCardContent>
              <Typography gutterBottom variant="caption" component="h1" style={{fontSize:'larger'}}>
                {cardData[7].tag}
              </Typography>
              <Typography gutterBottom variant="h1" component="h1" style={{fontSize:'medium'}}>
                {cardData[7].title}
              </Typography>
              <StyledTypography variant="body2" color="text.secondary" gutterBottom>
                {cardData[7].description}
              </StyledTypography>
            </SyledCardContent>
            <Author authors={cardData[7].authors} />
          </SyledCard>
        </Grid>
        
        <Grid size={{ xs: 12, md: 4 }}>
          <SyledCard
            variant="outlined"
            onFocus={() => handleFocus(5)}
            onBlur={handleBlur}
            tabIndex={0}
            className={focusedCardIndex === 5 ? 'Mui-focused' : ''}
            sx={{ height: '100%' }}
          >
            <CardMedia
              component="img"
              alt="green iguana"
              image={cardData[10].img}
              sx={{
                height: { sm: 'auto', md: '50%' },
                aspectRatio: { sm: '16 / 9', md: '' },
              }}
            />
            <SyledCardContent>
              <Typography gutterBottom variant="caption" component="h1" style={{fontSize:'larger'}}>
                {cardData[10].tag}
              </Typography>
              <Typography gutterBottom variant="h1" component="h1" style={{fontSize:'medium'}}>
                {cardData[10].title}
              </Typography>
              <StyledTypography variant="body2" color="text.secondary" gutterBottom>
                {cardData[10].description}
              </StyledTypography>
            </SyledCardContent>
            <Author authors={cardData[10].authors} />
          </SyledCard>
        </Grid>
      </Grid>
      
      <Grid size={{ xs: 12, md: 4 }}>
          <SyledCard
            variant="outlined"
            onFocus={() => handleFocus(5)}
            onBlur={handleBlur}
            tabIndex={0}
            className={focusedCardIndex === 5 ? 'Mui-focused' : ''}
            sx={{ height: '100%' }}
          >
            <CardMedia
              component="img"
              alt="green iguana"
              image={cardData[8].img}
              sx={{
                height: { sm: 'auto', md: '50%' },
                aspectRatio: { sm: '16 / 9', md: '' },
              }}
            />
            <SyledCardContent>
              <Typography gutterBottom variant="caption" component="h1" style={{fontSize:'larger'}}>
                {cardData[8].tag}
              </Typography>
              <Typography gutterBottom variant="h1" component="h1" style={{fontSize:'medium'}}>
                {cardData[8].title}
              </Typography>
              <StyledTypography variant="body2" color="text.secondary" gutterBottom>
                {cardData[8].description}
              </StyledTypography>
            </SyledCardContent>
            <Author authors={cardData[8].authors} />
          </SyledCard>
        </Grid>
        
        <Grid size={{ xs: 12, md: 4 }}>
          <SyledCard
            variant="outlined"
            onFocus={() => handleFocus(5)}
            onBlur={handleBlur}
            tabIndex={0}
            className={focusedCardIndex === 5 ? 'Mui-focused' : ''}
            sx={{ height: '100%' }}
          >
            <CardMedia
              component="img"
              alt="green iguana"
              image={cardData[9].img}
              sx={{
                height: { sm: 'auto', md: '50%' },
                aspectRatio: { sm: '16 / 9', md: '' },
              }}
            />
            <SyledCardContent>
              <Typography gutterBottom variant="caption" component="h1" style={{fontSize:'larger'}}>
                {cardData[9].tag}
              </Typography>
              <Typography gutterBottom variant="h1" component="h1" style={{fontSize:'medium'}}>
                {cardData[9].title}
              </Typography>
              <StyledTypography variant="body2" color="text.secondary" gutterBottom>
                {cardData[9].description}
              </StyledTypography>
            </SyledCardContent>
            <Author authors={cardData[9].authors} />
          </SyledCard>
        </Grid>
        
    </Box>
  );
}
